var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex position-absolute position-bottom-0 position-right-0 pr-2 pb-2 font-medium-1 font-weight-bold text-primary"},[_vm._v(" "+_vm._s(_vm.version)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }